import { enhancedApi } from './generated/filevineOrganizationService';

export const {
  useFilevineOrganizationLinkGetQuery,
  useFilevineOrganizationLinkCreateMutation,
  useFilevineOrganizationsListQuery,
  useFilevineOrganizationUnlinkMutation,
  useFilevineSectionConfigsListQuery,
  useFilevineSectionConfigRetrieveQuery,
  useFilevineSectionConfigUpdateTypeMutation,
  useFilevineProjectConfigsListQuery,
  useFilevineProjectConfigSyncTriggerMutation,
} = enhancedApi;

export type {
  FilevineOrganizationWithLinkStatusSchema,
  FilevineProjectConfigWithSectionsSchema,
  FilevineSectionConfigDetailedSchema,
  FirmFilevineOrganizationLinkSchema,
  LinkFirmToOrganizationSchema,
} from './generated/filevineOrganizationService';
